<script lang="jsx">
const InlineForm = ({ submit = e => e.preventDefault(), withExport = false}, {slots}) => {
    return (
      <form onSubmit={submit} class={withExport ? 'inline export-form' : 'inline'}>
        {slots.default().map(child => <div>{child}</div>)}
      </form>
    );
};
export default InlineForm;
</script>
